import { PlayerColor } from 'features/board/board'
import { Game, GameEvent, GameEventType } from 'features/firebase/types'
import { HexId } from 'features/hex-board/hex-board'
import { getHexPosition } from 'features/hex-board/utils'
import { SoundContextType } from 'features/sound/sound-context'

export const getGameClock = (events: GameEvent[], timeToPlay: number) =>
  events.length
    ? events[events.length - 1].clock
    : {
        white: timeToPlay,
        black: timeToPlay,
      }

export const switchRestrictions = (events: GameEvent[], hexes: HexId[]) => {
  if (events.length < 2) return false

  const { type, metadata } = events[events.length - 2]
  if (type === 'switch' && hexes.includes(metadata.from) && hexes.includes(metadata.to)) {
    return true
  }

  return false
}

export const isGameOpen = (gameStatus: Game['status']) => gameStatus === 'playing'

export const getRandomColor = () => (Math.random() < 0.5 ? 'white' : 'black')

const pad = (num: number, size = 2) => String(num).padStart(size, '0')

export const formatRemainingTime = (milliseconds: number) => {
  const totalSeconds = Math.floor(milliseconds / 1000)
  const minutes = Math.floor(totalSeconds / 60)
  const remainingSeconds = totalSeconds % 60

  return `${pad(minutes)}:${pad(remainingSeconds)}`
}

export const getCenterOfHexes = (playerColor: PlayerColor, [h1, h2]: [HexId, HexId]) => {
  const pos1 = getHexPosition({ playerColor, hexId: h1 })
  const pos2 = getHexPosition({ playerColor, hexId: h2 })

  return {
    x: (pos1.x + pos2.x) / 2 + 137 - 60,
    y: (pos1.y + pos2.y) / 2 + 150 - 60,
  }
}

export const playEventSound = (eventType: GameEventType, sounds: SoundContextType) => {
  switch (eventType) {
    case 'deploy':
    case 'distribute':
      return sounds.playDeploySound()
    case 'move':
      return sounds.playMoveSound()
    case 'fight':
      return sounds.playFightSound()
    case 'switch':
      return sounds.playSwitchSound()
    case 'withdraw':
      return sounds.playWithdrawSound()
  }
}

export const getGameNumber = (gameId: string) => gameId.split('').reduce((sum, char) => sum + char.charCodeAt(0), 0)
